import React, { useState, useEffect } from 'react';
import './CommentModal.module.css';
import RollbackIcon from '../../Icon/RollbackIcon';
import { Modal, Textarea, ActionIcon } from '@mantine/core';
// import { BaseModal } from '../BaseModel';
import { useMantineTheme } from '@mantine/core';

const CommentModal = ({ isOpen, onClose, onRollback, comment, onCommentChange, hasPreviousComment }) => {
    const [newComment, setNewComment] = useState('');
    const theme = useMantineTheme();

    useEffect(() => {
        // Loại bỏ khoảng trắng và dòng trống ở đầu/cuối
        setNewComment(comment ? comment.trim() : '');
    }, [comment]);

    if (!isOpen) return null;

    const handleCommentChange = (e) => {
        setNewComment(e.target.value);
    };

    const handleSaveAndClose = () => {
        const trimmedComment = newComment.trim();
        if (trimmedComment !== comment) {
            onCommentChange(trimmedComment);
        }
        onClose(trimmedComment);
    };

    const handleSave = () => {
        const trimmedComment = newComment.trim();
        if (trimmedComment !== comment) {
            onCommentChange(trimmedComment);
        }
    };

    const handleRollbackClick = (e) => {
        e.stopPropagation();
        onRollback();
        handleSave();
    };

    const handleTextareaMouseDown = (e) => {
        e.stopPropagation();
    };

    const handleTextareaSelectStart = (e) => {
        e.stopPropagation();
    };

    const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key === 'v') {
            e.stopPropagation();
        }
    };

    const handlePaste = (e) => {
        e.stopPropagation();
    };

    return (
        <Modal
            opened={isOpen}
            onClose={handleSaveAndClose}
            onDoubleClick={(e) => e.stopPropagation()}
            title={
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', color: theme.colorScheme === 'dark' ? '#fff' : '#000' }}>
                    <span style={{ fontSize: '16px', fontWeight: 500 }}>Add comment</span>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <ActionIcon
                            onClick={handleRollbackClick}
                            disabled={!hasPreviousComment}
                            onDoubleClick={(e) => e.stopPropagation()}
                            title="Rollback to previous comment"
                            size="sm"
                            variant="subtle"
                            color="gray"
                            style={{ opacity: hasPreviousComment ? 1 : 0.5 }}
                        >
                            <RollbackIcon />
                        </ActionIcon>
                    </div>
                </div>
            }
            size="sm"
            centered
            styles={{
                root: {
                    '.mantine-Modal-modal': {
                        padding: '0 !important',
                    }
                },
                header: {
                    padding: '16px 20px',
                    marginBottom: 0,
                    borderBottom: '1px solid #eee',
                },
                title: {
                    width: '100%',
                    margin: 0,
                },
                close: {
                    color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
                    '&:hover': {
                        backgroundColor: 'transparent',

                    },
                },
                body: {
                    padding: '0',
                },
            }}
        >
            <div
                className="modal-content-wrapper"
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
            >
                <Textarea
                    value={newComment}
                    onChange={handleCommentChange}
                    placeholder="Write a comment..."
                    autosize
                    minRows={4}
                    maxRows={8}
                    maxLength={255}
                    onDoubleClick={(e) => e.stopPropagation()}
                    onMouseDown={handleTextareaMouseDown}
                    onSelectStart={handleTextareaSelectStart}
                    onBlur={handleSave}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    styles={{
                        root: {
                            padding: '16px 20px',
                        },
                        input: {
                            userSelect: 'text',
                            backgroundColor: 'transparent',
                            color: theme.colorScheme === 'dark' ? '#fff' : '#000',
                            border: 'none',
                            padding: '0',
                            fontSize: '14px',
                            lineHeight: '1.5',
                            '&:focus': {
                                border: 'none',
                                outline: 'none',
                            },
                            '&::placeholder': {
                                color: theme.colorScheme === 'dark' ? '#fff' : '#000',
                            },
                        },
                    }}
                />
                <div style={{
                    textAlign: 'right',
                    padding: '0 20px 16px',
                    fontSize: '12px',
                    color: newComment.length >= 255 ? '#fa5252' : '#aaa'
                }}>
                    {newComment.length}/255 characters
                </div>
            </div>
        </Modal>
    );
};

export default CommentModal;